module.exports = __webpack_public_path__ + "static/Marvella Francis Deacon-f1095118937e70c3bbd3e0ab86feb06a.jpg";